"use strict";

export default function obrasFilter() {
    document.addEventListener("DOMContentLoaded", () => {
        const form = document.querySelector("#obrasFilterForm");
        if (!form) return;

        const selects = form.querySelectorAll("select");

        selects.forEach((select) => {
            console.log(select);
            select.addEventListener("change", () => {
                // Monta a nova URL com os parâmetros selecionados
                const params = new URLSearchParams(window.location.search);

                selects.forEach((s) => {
                    const name = s.name;
                    const value = s.value.trim();
                    if (value) {
                        params.set(name, value);
                    } else {
                        params.delete(name);
                    }
                });

                const newUrl =
                    window.location.pathname +
                    (params.toString() ? "?" + params.toString() : "");

                // Redireciona automaticamente (sem botão)
                window.location.href = newUrl;
            });
        });
    });
}
